import { useEffect, useState } from "react";

import displayToast from "@common/components/Toast/displayToast";
import useScoringConfig, { ScoringConfigKeys } from "@main/pages/Release/consumers/useScoringConfig";

export default function useEndpointHealthScoring(refetchReleaseStatus: () => void) {
  const { scoringConfig, scoringConfigLoading, scoringConfigError, saveScoringConfig, isSaving } = useScoringConfig(
    ScoringConfigKeys.network_health,
  );

  const [factorA, setFactorA] = useState(0.7);
  const [factorB, setFactorB] = useState(0.3);
  const [factorC, setFactorC] = useState(50);
  const [weightD, setWeightD] = useState(60);
  const [weightE, setWeightE] = useState(40);

  useEffect(() => {
    const config = scoringConfig?.config;
    if (!config) return;

    if (config.tx_3xx_weight !== undefined) setFactorA(config.tx_3xx_weight);
    if (config.tx_4xx_weight !== undefined) setFactorB(config.tx_4xx_weight);
    if (config.tx_5xx_severity !== undefined) setFactorC(config.tx_5xx_severity);
    if (config.min_weight !== undefined) setWeightD(Math.round(config.min_weight * 100));
    if (config.mean_weight !== undefined) setWeightE(Math.round(config.mean_weight * 100));
  }, [scoringConfig]);

  const weightSum = weightD + weightE;
  const weightError = weightSum !== 100 ? `d + e must equal 100%. It is currently ${weightSum}%.` : undefined;

  const handleSave = () => {
    saveScoringConfig(
      {
        tx_3xx_weight: factorA,
        tx_4xx_weight: factorB,
        tx_5xx_severity: factorC,
        min_weight: weightD / 100,
        mean_weight: weightE / 100,
      },
      {
        onSuccess: () => {
          refetchReleaseStatus();
          displayToast({ title: "Saved successfully", content: "Your scoring configuration is saved." });
        },
        onError: () => {
          displayToast({ title: "Something went wrong", content: "Please try again." });
        },
      },
    );
  };

  return {
    factorA,
    setFactorA,
    factorB,
    setFactorB,
    factorC,
    setFactorC,
    weightD,
    setWeightD,
    weightE,
    setWeightE,
    weightError,
    scoringConfigLoading,
    scoringConfigError,
    handleSave,
    isSaving,
  };
}
